import { createSelector } from 'reselect';

export const selectUser = state => state.user;

export const selectUserAuthToken = createSelector(selectUser, auth => {
  return auth.userAuthToken;
});

export const selectUserAuth = createSelector(selectUser, user => user.auth);
